export default __webpack_public_path__ + "static/media/step-two.72723063.png";